<template>
  <span class="icon" :class="[sizeClassName]">
    {{ iconText }}
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  computed: {
    sizeClassName() {
      return `--${this.size}`;
    },
    iconText() {
      switch (this.name) {
        case 'home':
          return '\uf015';
        case 'config':
          return '\uf013';
        case 'arrow-bottom':
          return '\uf078';
      }
      throw new Error(`${this.name} is not registered`);
    },
  },
};
</script>

<style lang="sass">
.icon
  font-family: "FontAwesome"
  width: 18px
  height: 18px
  line-height: 18px
  text-align: center

.icon.--medium
  width: 18px
  height: 18px
  line-height: 18px
  font-size: 18px

.icon.--small
  width: 18px
  height: 18px
  line-height: 18px
  font-size: 10px
</style>
